// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 94px;
  background-color: #ffffff;
}
.wrapper .corner {
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 38px;
}

ion-checkbox {
  --background: transparent;
}

.header_block {
  margin-top: 20px;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header_block ion-icon {
  height: 44px;
  width: 44px;
}

.logo {
  max-height: 120px;
  height: 40%;
  margin: auto;
}

.title {
  font-family: AppFontMedium;
  font-size: 20px;
  line-height: 24.8px;
  text-align: center;
  margin-bottom: 18px;
}

.info {
  font-family: AppFont;
  font-size: 14px;
  line-height: 16.8px;
  text-align: center;
  color: #000;
  margin-bottom: 25px;
}
.info strong {
  font-family: AppFontMedium;
}

.warning-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 25px;
}

.policy-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 25px;
}

ul {
  list-style-type: none;
  padding: 0px 20px;
}

li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
  text-decoration: none;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.031372549);
}
li .wrapper-inner {
  background: white;
  width: 100%;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
li .wrapper-inner .info_block {
  border-radius: 20px;
  display: flex;
  align-items: center;
}
li .wrapper-inner .info_block p {
  padding: 0px 10px;
  color: var(--ion-color-primary);
  font-family: AppFont, sans-serif;
}
li .wrapper-inner .info_block ion-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
}
li .wrapper-inner .circle {
  width: 30px;
  height: 30px;
  content: " ";
  border: 2px solid var(--ion-color-secondary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
li .wrapper-inner .circle .cirle_inner {
  width: 22px;
  height: 22px;
  content: " ";
  background: transparent;
  border-radius: 50%;
}
li .wrapper-inner .circle .cirle_inner.selected {
  background: var(--ion-color-secondary);
  border-radius: 50;
  transition: ease-in-out 0.3s;
}

.line-border {
  padding: 0px 20px;
}
.line-border ion-icon {
  fill: white;
  width: 100%;
}

.footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px;
  display: flex;
  justify-content: center;
}
.footer-item ion-button {
  font-family: AppFontMedium, sans-serif;
  width: 100%;
  font-size: 16px;
}

.block-checkbox {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px 0px;
  cursor: pointer;
}
.block-checkbox ion-checkbox {
  --checkmark-color: #fff;
  pointer-events: none;
  margin-right: 12px;
  flex-shrink: 0;
}
@media (max-width: 992px) {
  .block-checkbox ion-checkbox {
    margin-top: -1px;
  }
}

.wrapper-block {
  padding: 0px 20px 20px;
}

.age-info {
  font-family: AppFont;
  font-size: 14px;
  line-height: 16.8px;
  color: var(--color-black);
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/app/components/confirm-year-dialog/confirm-year-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;AADD;AAGC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AADF;;AAKA;EACC,yBAAA;AAFD;;AAKA;EACC,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFD;AAIC;EACC,YAAA;EACA,WAAA;AAFF;;AAMA;EACC,iBAAA;EACA,WAAA;EACA,YAAA;AAHD;;AAMA;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAHD;;AAMA;EACC,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAHD;AAKC;EACC,0BAAA;AAHF;;AAOA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAJD;;AAOA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAJD;;AAOA;EACC,qBAAA;EACA,iBAAA;AAJD;;AAOA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,uDAAA;AAJD;AAMC;EACC,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAJF;AAME;EACC,mBAAA;EACA,aAAA;EACA,mBAAA;AAJH;AAMG;EACC,iBAAA;EACA,+BAAA;EACA,gCAAA;AAJJ;AAOG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AALJ;AASE;EACC,WAAA;EACA,YAAA;EACA,YAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPH;AASG;EACC,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAPJ;AASI;EACC,sCAAA;EACA,iBAAA;EACA,4BAAA;AAPL;;AAcA;EACC,iBAAA;AAXD;AAaC;EACC,WAAA;EACA,WAAA;AAXF;;AAeA;EACC,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAZD;AAcC;EACC,sCAAA;EACA,WAAA;EACA,eAAA;AAZF;;AAgBA;EACC,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;AAbD;AAeC;EACC,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AAbF;ACtKE;ED+KD;IAOE,gBAAA;EAZD;AACF;;AAgBA;EACC,sBAAA;AAbD;;AAgBA;EACC,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAbD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: auto;\n\tpadding-bottom: 94px;\n\tbackground-color: #ffffff;\n\n\t.corner {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 50px;\n\t\theight: 38px;\n\t}\n}\n\nion-checkbox {\n\t--background: transparent;\n}\n\n.header_block {\n\tmargin-top: 20px;\n\tmargin-bottom: 5px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tion-icon {\n\t\theight: 44px;\n\t\twidth: 44px;\n\t}\n}\n\n.logo {\n\tmax-height: 120px;\n\theight: 40%;\n\tmargin: auto;\n}\n\n.title {\n\tfont-family: AppFontMedium;\n\tfont-size: 20px;\n\tline-height: 24.8px;\n\ttext-align: center;\n\tmargin-bottom: 18px;\n}\n\n.info {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 16.8px;\n\ttext-align: center;\n\tcolor: #000;\n\tmargin-bottom: 25px;\n\n\tstrong {\n\t\tfont-family: AppFontMedium;\n\t}\n}\n\n.warning-text {\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 16px;\n\ttext-align: center;\n\tcolor: var(--color-black);\n\tmargin-bottom: 25px;\n}\n\n.policy-text {\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 16px;\n\ttext-align: center;\n\tcolor: var(--color-black);\n\tmargin-bottom: 25px;\n}\n\nul {\n\tlist-style-type: none;\n\tpadding: 0px 20px;\n}\n\nli {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tbox-shadow: 0px 4px 10px 0px #00000008;\n\n\t.wrapper-inner {\n\t\tbackground: white;\n\t\twidth: 100%;\n\t\tborder-radius: 2px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\n\t\t.info_block {\n\t\t\tborder-radius: 20px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\tp {\n\t\t\t\tpadding: 0px 10px;\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t}\n\n\t\t\tion-img {\n\t\t\t\twidth: 30px;\n\t\t\t\theight: 30px;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\toverflow: hidden;\n\t\t\t}\n\t\t}\n\n\t\t.circle {\n\t\t\twidth: 30px;\n\t\t\theight: 30px;\n\t\t\tcontent: ' ';\n\t\t\tborder: 2px solid var(--ion-color-secondary);\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\t.cirle_inner {\n\t\t\t\twidth: 22px;\n\t\t\t\theight: 22px;\n\t\t\t\tcontent: ' ';\n\t\t\t\tbackground: transparent;\n\t\t\t\tborder-radius: 50%;\n\n\t\t\t\t&.selected {\n\t\t\t\t\tbackground: var(--ion-color-secondary);\n\t\t\t\t\tborder-radius: 50;\n\t\t\t\t\ttransition: ease-in-out 0.3s;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.line-border {\n\tpadding: 0px 20px;\n\n\tion-icon {\n\t\tfill: white;\n\t\twidth: 100%;\n\t}\n}\n\n.footer-item {\n\tposition: fixed;\n\tleft: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tpadding: 20px;\n\tdisplay: flex;\n\tjustify-content: center;\n\n\tion-button {\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\twidth: 100%;\n\t\tfont-size: 16px;\n\t}\n}\n\n.block-checkbox {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\tpadding: 10px 0px;\n\tcursor: pointer;\n\n\tion-checkbox {\n\t\t--checkmark-color: #fff;\n\t\tpointer-events: none;\n\t\tmargin-right: 12px;\n\t\tflex-shrink: 0;\n\n\t\t@include mobile {\n\t\t\tmargin-top: -1px;\n\t\t}\n\t}\n}\n\n.wrapper-block {\n\tpadding: 0px 20px 20px;\n}\n\n.age-info {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 16.8px;\n\tcolor: var(--color-black);\n\ttext-align: left;\n}\n\n// .btn {\n// \twidth: 100%;\n// \theight: 54px;\n// \tbackground: var(--ion-color-primary);\n// \tborder-radius: var(--radius-default);\n// \tdisplay: flex;\n// \tjustify-content: center;\n// \talign-items: center;\n// \tcursor: pointer;\n// \ttransition: opacity 0.3s ease;\n\n// \t@include desktop {\n// \t\theight: 67px;\n// \t}\n\n// \t&.disabled {\n// \t\topacity: 0.5;\n// \t\tcursor: not-allowed;\n// \t}\n\n// \tspan {\n// \t\tfont-family: AppFont, sans-serif;\n// \t\tcolor: #000;\n// \t\tfont-size: 16px;\n// \t\tline-height: 19.2px;\n// \t\tletter-spacing: 0.01em;\n// \t}\n// }\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
